// ─── Permission groups ────────────────────────────────────────────────────
// كل الثوابت هنا عشان App.js يفضل نضيف، وأي تعديل في الصلاحيات يبقى من مكان واحد.

export const ALL_VIEW_PERMS = [
  "Construction.View", "Emergency.View", "Maintenance.View",
  "NewProject.View", "PrivateProject.View", "Attendance.View",
  "LeaveRequest.View", "Custody.View", "Employees.View",
  "Branch.View", "Office.View", "Neighborhood.View",
  "Consultant.View", "Contractor.View", "WorkOrderType.View",
  "JobDescription.View", "Notifications.View", "Users.View",
];

export const PROJECT_VIEW_PERMS = [
  "Construction.View", "Emergency.View",
  "Maintenance.View", "NewProject.View", "PrivateProject.View",
];

export const PROJECT_UPDATE_PERMS = [
  "Construction.Update", "Emergency.Update",
  "Maintenance.Update", "NewProject.Update", "PrivateProject.Update",
];

/** التحديث اليومي: تعديل أمر العمل أو صلاحية «تسجيل تنفيذ» المستقلة. */
export const DAILY_EXECUTION_PERMS = [
  ...PROJECT_UPDATE_PERMS,
  "Construction.Execute", "Emergency.Execute", "Maintenance.Execute",
];

/** المساعد الذكي: لمن يتعامل مع أوامر العمل (عرض/إنشاء/تعديل/تنفيذ). كل أداة فيه تتحقق من صلاحياته على الخادم. */
export const AI_ASSISTANT_PERMS = [
  ...PROJECT_VIEW_PERMS,
  "Construction.Create", "Emergency.Create", "Maintenance.Create", "NewProject.Create", "PrivateProject.Create",
  ...DAILY_EXECUTION_PERMS,
];

export const ALL_APPROVE_PERMS = [
  "Construction.Approve", "Emergency.Approve",
  "Maintenance.Approve", "NewProject.Approve", "PrivateProject.Approve",
];

export const ALL_DELETE_PERMS = [
  "Construction.Delete", "Emergency.Delete",
  "Maintenance.Delete", "NewProject.Delete", "PrivateProject.Delete",
];

// ─── الهيكل الموحّد ─────────────────────────────────────────────────────────
// لا Layout ولا قائمة ولا صفحة رئيسية بحسب نوع الحساب: كل مستخدم مسجّل يدخل نفس الهيكل،
// والصلاحيات وحدها تحدد ما يظهر. الصفحة الرئيسية الموحّدة لكل الحسابات:
export const HOME_ROUTE = "/home";
